import React, { useEffect, useState } from "react";
import { X, Star, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { avatarSrc } from "@/lib/defaults";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { localeFor } from "@/lib/dateLocale";

import { quoteLabel as label } from "./QuoteThumb";

// ⭐ Mes messages importants (toutes conversations) — clic : aller au message.
export const StarredSheet = ({ open, t, lang, isMobile, onClose, onPick }) => {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    if (!open) return;
    setRows(null);
    api.get("/chat/starred").then(({ data }) => setRows(data.messages || [])).catch(() => setRows([]));
  }, [open]);
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[97] flex items-end sm:items-center justify-center bg-black/50" data-testid="chat-starred-sheet" onClick={onClose}>
      <div className="bg-white w-full sm:max-w-md sm:rounded-2xl rounded-t-2xl max-h-[72vh] flex flex-col overflow-hidden" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between px-4 py-3 border-b" style={{ borderColor: "var(--yalola-border)" }}>
          <div className="font-bold text-base flex items-center gap-2" style={{ color: "var(--yalola-text)" }}><Star size={18} fill="#E0A63C" style={{ color: "#E0A63C" }} /> {t("conv.starred", "Messages importants")}</div>
          <button onClick={onClose} className="h-8 w-8 grid place-items-center rounded-full hover:bg-[color:var(--yalola-surface-alt)]" style={{ color: "var(--yalola-text-muted)" }} data-testid="chat-starred-close"><X size={18} /></button>
        </div>
        <div className="flex-1 overflow-y-auto px-2 py-2" style={{ paddingBottom: isMobile ? "calc(0.75rem + var(--sa-bottom))" : undefined }}>
          {rows === null && <div className="py-8 text-center"><Loader2 size={18} className="animate-spin mx-auto" style={{ color: "var(--yalola-primary)" }} /></div>}
          {rows && rows.length === 0 && <div className="text-center text-xs py-8 px-4" style={{ color: "var(--yalola-text-muted)" }} data-testid="chat-starred-empty">{t("conv.starred_empty", "Aucun message important. Sélectionne un message puis touche ⭐.")}</div>}
          {rows && rows.map((m) => (
            <button key={m.id} onClick={() => onPick(m)} className="w-full flex items-center gap-3 px-2 py-2.5 rounded-lg hover:bg-[color:var(--yalola-surface-alt)] text-left" data-testid={`chat-starred-item-${m.id}`}>
              <Avatar className="h-9 w-9 shrink-0"><AvatarImage src={avatarSrc(m.peer)} /><AvatarFallback>{m.peer?.name?.[0]}</AvatarFallback></Avatar>
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between gap-2">
                  <span className="text-xs font-semibold truncate" style={{ color: "var(--yalola-text)" }}>{m.peer?.name || "—"}</span>
                  <span className="text-[10px] shrink-0" style={{ color: "var(--yalola-text-muted)" }}>{new Date(m.created_at).toLocaleDateString(localeFor(lang), { day: "numeric", month: "short" })}</span>
                </div>
                <div className="text-sm truncate" style={{ color: "var(--yalola-text-muted)" }}>{label(m, t)}</div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};
